import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    overrides: {
      MuiFormLabel: {
        root: {
          "&$focused": {
            color: "#414141",
            //fontWeight: "bold",
            borderColor: '#0B3845 !important'
          }
        }, 
        
        focused: {}
      }
    },
    palette: {
      primary: {
        main: '#004B81',
        /*light: "#0f4d5e",
        dark:"#12596d",*/
      }
    }  
  });